import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const AddAssignProject = ({list}) => {
    const [channels, setChannel] = useState([]);
    const [clients, setClients] = useState([]);
    const [projects, setProjects] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState('');
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [selectAll, setSelectAll] = useState(false); // State for "Select All" checkbox
    const [assignedEmployees, setAssignedEmployees] = useState([]);


    // VALIDATION RULES
    const schema = Yup.object().shape({
        channel_id: Yup.string().required('channel is a required field'),
        client_id: Yup.string().required('client is a required field'),
        project_id: Yup.string().required('project is a required field'),
        department_id: Yup.string().required('department is a required field'),
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        axiosInstance.post(`${process.env.REACT_APP_API_URL}/assign_project`, {
            ...data,
            employees: selectedEmployees
        }).then(response => {
                Swal.fire({ icon:"success", text:response.data.message});
                reset();
                closeModal("assign_project");
                list();
            })
            .catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    }

    const fetchChannels = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/channels`)
            .then(response => {
                setChannel(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching channels', error);
                setChannel([]);
            });
    };

    const fetchClients = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/clients`)
            .then(response => {
                setClients(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching clients', error);
                setClients([]);
            });
    }

    const fetchProjects = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/projects`)
            .then(response => {
                setProjects(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching projects!", error);
                setProjects([]);
            });
    };

    const fetchDepartments = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/department`)
            .then(response => {
                setDepartments(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching departments', error);
            });
    };

    const fetchEmployees = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=all`)
            .then(response => {
                setEmployees(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching employees!", error);
                setEmployees([]);
            });
    };

    useEffect(() => {
        fetchChannels();
        fetchClients();
        fetchProjects();
        fetchDepartments();
        fetchEmployees();

        const modalElement = document.getElementById('assign_project');

        const handleClose = () => {
            reset(); // Reset form when modal is closed
            setSelectedChannel('');
            setSelectedClient('');
            setSelectedDepartment('');
            setSelectedEmployees([]);
            setSelectAll(false);
        };

        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', handleClose);
        }
        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hidden.bs.modal', handleClose);
            }
        };
    }, [reset]);


    // Filter clients based on selected channel
    const filteredClients = selectedChannel 
        ? clients.filter(client => parseInt(client.channel_id) === parseInt(selectedChannel)) 
        : [];

    // Filter projects based on selected client
    const filteredProjects = selectedClient 
        ? projects.filter(project => parseInt(project.client_id) === parseInt(selectedClient)) 
        : [];

    // Filter employees based on department
    const filteredEmployees = selectedDepartment 
        ? employees.filter(employee => parseInt(employee.department_id) === parseInt(selectedDepartment)) 
        : [];


    //GET EMPLOYEE CHECKBOX DATA TO DISABLE OR NOT
    const fetchEmployeeData = async () => {
        try {
            //GET CHANNEL, CLIENT AND PROJECT IDs
            var channel_id = document.getElementById('channel_id').value;
            var client_id = document.getElementById('client_id').value;
            var project_id = document.getElementById('project_id').value;

            //GET DEPARTMENT ID
            var department_id = document.getElementById('department_id').value;
            if(department_id === ''){
                return false;
            }

            const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}/check_assigned_project`, {
                channel_id      : channel_id,
                client_id       : client_id,
                project_id      : project_id,
                department_id   : department_id
            });

            if(response.data.data !== ''){
                setAssignedEmployees(response.data.data.map(emp => parseInt(emp)));
            }else{
                setAssignedEmployees([]);
            }
        }
        catch (error) {
            console.log(error.message);                
        }
    }

    const handleProjectChange = () => {
        setSelectedEmployees([]);   // Uncheck all employees
        setSelectAll(false);        // Uncheck the "Select All" checkbox

        document.getElementById('department_id').value = '';
        setSelectedDepartment('');  // Reset department selection
        fetchEmployeeData();
    }

    const handleDepartmentChange = (event) => {
        //GET PROJECT ID
        var project_id = document.getElementById('project_id').value;
        if(project_id === ''){
            return false;
        }

        const department = event.target.value;
        setSelectedDepartment(department);

        setSelectedEmployees([]);   // Uncheck all employees
        setSelectAll(false);        // Uncheck the "Select All" checkbox

        fetchEmployeeData();
    }

    const handleEmployeeChange = (id, isChecked) => {
        if (isChecked) {
            setSelectedEmployees([...selectedEmployees, id]);
        } else {
            setSelectedEmployees(selectedEmployees.filter(employeeID => employeeID !== id));
        }
    }
    const handleSelectAllChange = (isChecked) => {
        if (isChecked) {
            setSelectedEmployees(filteredEmployees.map(employee => employee.id));
        } else {
            setSelectedEmployees([]);
        }
        setSelectAll(isChecked);
    }
    useEffect(() => {
        if (filteredEmployees.length > 0) {
            setSelectAll(filteredEmployees.every(employee => selectedEmployees.includes(employee.id)));
        }
    }, [selectedEmployees, filteredEmployees]);


    return (
        <div id="assign_project" className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Assign Project</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Channel <span className="text-danger">*</span></label>
                                        <select className="form-control" {...register('channel_id')} id="channel_id"
                                                onChange={(event) => {setSelectedChannel(event.target.value)}}>
                                            <option value="">Select Channel</option>
                                            {channels.map(channel => (
                                                <option key={channel.id} value={channel.id}>{channel.name}</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.channel_id && <p>{errors.channel_id.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Client <span className="text-danger">*</span></label>
                                        <select className="form-control" {...register('client_id')} id="client_id"
                                                onChange={(event) => {setSelectedClient(event.target.value)}}>
                                            <option value="">Select Client</option>
                                            {filteredClients.map(client => (
                                                <option key={client.id} value={client.id}>{client.name}</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.client_id && <p>{errors.client_id.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Project <span className="text-danger">*</span></label>
                                        <select className="form-control" {...register('project_id')} id="project_id"
                                            onChange={handleProjectChange}>
                                            <option value="">Select Project</option>
                                            {filteredProjects.map(project => (
                                                <option key={project.id} value={project.id}>{project.title}</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.project_id && <p>{errors.project_id.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Department <span className="text-danger">*</span></label>
                                        <select className="form-control" {...register('department_id')} id="department_id"
                                                onChange={handleDepartmentChange}>
                                            <option value="">Select Department</option>
                                            {departments.map(dep => (
                                                <option key={dep.id} value={dep.id}>{dep.name}</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.department_id && <p>{errors.department_id.message}</p>}
                                        </div>
                                    </div>
                                </div>
                               
                                <div className="table-responsive m-t-15">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Employees</th>
                                                <th className="text-center">
                                                    {filteredEmployees.length > 0 &&
                                                        <>
                                                            Select All &nbsp;&nbsp;
                                                            <input type="checkbox" 
                                                                checked={selectAll}
                                                                onChange={(e) => handleSelectAllChange(e.target.checked)}
                                                            />
                                                        </>
                                                    }
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredEmployees.length > 0 ? (
                                                filteredEmployees.map((employee) => (
                                                    <tr key={employee.id}>
                                                        <td>{employee.name}</td>
                                                        <td className="text-center">
                                                            <label className="custom_check">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={(e) => handleEmployeeChange(employee.id, e.target.checked)}
                                                                    checked={selectedEmployees.includes(employee.id) || assignedEmployees.includes(employee.id)}
                                                                    disabled={assignedEmployees.includes(employee.id)}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                )))
                                                :
                                                <tr>
                                                    <td className="text-center" colSpan="2">No employee found</td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddAssignProject